var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 60,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Email")]),
          ]
        ),
      ]),
      _c(
        "section",
        {
          staticClass: "modal-card-body p-0 m-0",
          staticStyle: { position: "relative" },
        },
        [
          _c("div", { staticClass: "columns p-0 m-0" }, [
            _c("div", { staticClass: "column p-0 m-0" }, [
              _c("div", { staticClass: "p-0 m-0" }, [
                _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                  _c("div", { staticClass: "column is-9 p-3 m-0" }, [
                    _vm._v(" From: "),
                    _c("b", [_vm._v(_vm._s(_vm.email.sender))]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "column is-3 p-3 m-0 has-text-right" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$filters.formatDateTimeLocale(
                              _vm.email.createdDate,
                              _vm.$userInfo.locale
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "columns p-0 m-0" }, [
            _c("div", { staticClass: "column p-0 m-0" }, [
              _c("div", { staticClass: "p-0 m-0" }, [
                _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                  _c("div", { staticClass: "column is-full p-3 m-0" }, [
                    _vm._v(" To : "),
                    _c("b", [_vm._v(_vm._s(_vm.email.recipients))]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.email.cc && _vm.email.cc.length,
                  expression: "email.cc && email.cc.length",
                },
              ],
              staticClass: "columns p-0 m-0",
            },
            [
              _c("div", { staticClass: "column p-0 m-0" }, [
                _c("div", { staticClass: "p-0 m-0" }, [
                  _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                    _c("div", { staticClass: "column is-full p-3 m-0" }, [
                      _vm._v(" Cc : "),
                      _c("b", [_vm._v(_vm._s(_vm.email.cc))]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.email.bcc && _vm.email.bcc.length,
                  expression: "email.bcc && email.bcc.length",
                },
              ],
              staticClass: "columns p-0 m-0",
            },
            [
              _c("div", { staticClass: "column p-0 m-0" }, [
                _c("div", { staticClass: "p-0 m-0" }, [
                  _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                    _c("div", { staticClass: "column is-full p-3 m-0" }, [
                      _vm._v(" Bcc : "),
                      _c("b", [_vm._v(_vm._s(_vm.email.bcc))]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "columns p-0 m-0" }, [
            _c("div", { staticClass: "column p-0 m-0" }, [
              _c("div", { staticClass: "box p-0 m-0" }, [
                _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                  _c("div", { staticClass: "column is-full p-3 m-0" }, [
                    _c("b", [_vm._v(_vm._s(_vm.email.subject))]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "columns p-0 m-0" }, [
            _c("div", { staticClass: "column p-0 m-0" }, [
              _c("div", { staticClass: "box p-0 m-0" }, [
                _c("div", { staticClass: "columns is-multiline p-0 m-0" }, [
                  _c("div", { staticClass: "column is-full p-3 m-0" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.getHtmlMessage()) },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c("div", { staticStyle: { "align-self": "flex-start" } }),
            _c("div", { staticStyle: { "align-self": "flex-end" } }, [
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Close")]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }